// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__U6yEr","clinicsSelect":"TableHeading_clinicsSelect__2rp4i"};